import type { FeatureFlag } from '@/shared/lib/types/relyingParty';
import { useFeatureFlagStore } from '@/shared/model';

export const useFeatureFlag = (flagName: FeatureFlag) => {
  return useFeatureFlagStore(state => state.isFeatureEnabled(flagName));
};
